import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries';

import general from '../../../modulos/general';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrClaseServ" id="miLista4" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES
//dropdown TERCEROS
const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaTerceros = ({styles, handleChange, list, numeroDocumUA, a150520}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
  // console.log(sessionStorage.getItem('userLogin'))
  if(a150520!==-1&&sessionStorage.getItem('userLogin')!=="foroptic@foroptic.com"){
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miLista5" onChange={(ev)=>handleChange(ev)}>
          <option style={styles.input} value="">Pago en oficina</option>
        </select>
      </div>
    )
  }else{
    if(numeroDocumUA === "Todos..."){
      return(
        <div>
          <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miLista5" onChange={(ev)=>handleChange(ev)}>
            <option style={styles.input} value="">Todo</option>
            <option style={styles.input} value="">Pago en oficina</option>
            <option style={styles.input} value="">Pago en App</option>
            <option style={styles.input} value="">Tercero</option>
            {NivelDetalleTipo}
          </select>
        </div>
      )
    }else{
      return(
        <div>
          <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miLista5" onChange={(ev)=>handleChange(ev)}>
            {NivelDetalleTipo}
          </select>
        </div>
      )
    }
  }
};
//Fin dropdown TERCEROS
//dropdown USUARIOS
const DetalleNivelUser = props => {
  return (
    <option dato1={props.elemento.usuarioCreate}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaUsr = ({styles, handleChange, list}) => {
  const NivelDetalleUser = list.map((elemento, _id) => <DetalleNivelUser elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="usuarioCreate" id="miLista6" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {NivelDetalleUser}
      </select>
    </div>
  )
};
//Fin dropdown USUARIOS

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, argsDocum, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrOficina" id="miListaOf" onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

//Lista de movimientos de recaudo
const RdoDet = ({elemento, opciones, opciones1, checkNoFactMPF}) => {
  if(opciones==="opcion1"||opciones==="opcion7"){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaPago}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroRC}</td>
        <td className=''>{elemento.numeroRT}</td>
        {/* <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td> */}

        <td className='right aligned'>{elemento.valorTotal?general.formatNum(elemento.valorTotal.toString()):0}</td>
        <td className='right aligned'>{elemento.valorEf?general.formatNum(elemento.valorEf.toString()):0}</td>
        <td className='right aligned'>{elemento.valorCh?general.formatNum(elemento.valorCh.toString()):0}</td>
        <td className='right aligned'>{elemento.valorTr?general.formatNum(elemento.valorTr.toString()):0}</td>
        <td className='right aligned'>{elemento.valorTD?general.formatNum(elemento.valorTD.toString()):0}</td>
        <td className='right aligned'>{elemento.valorTC?general.formatNum(elemento.valorTC.toString()):0}</td>


        {/* <td className='right aligned'>{general.formatNum(elemento.valorEf.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorCh.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTr.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTD.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTC.toString())}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrOficina}</td>
        <td className=''>{opciones==="opcion7"?elemento.razonap:elemento.nombreUsuario}</td>
        {/* <td className=''>{elemento.codigoZona}</td>
        <td className=''>{elemento.codigoCiudad}</td> */}
      </tr>
    )
  }
  if(opciones==="opcion2"){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaPago}</td>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className=''>{elemento.periodo}</td>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroRC}</td>
        <td className=''>{elemento.numeroRT}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorDetalle.toString())}</td>
        {/* <td className='right aligned'>{elemento.valorEf}</td>
        <td className='right aligned'>{elemento.valorCh}</td>
        <td className='right aligned'>{elemento.valorTr}</td>
        <td className='right aligned'>{elemento.valorTD}</td>
        <td className='right aligned'>{elemento.valorTC}</td>
        <td className='right aligned'>{elemento.valorDetalle}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.nombreUsuario}</td>
        {/* <td className=''>{elemento.codigoZona}</td>
        <td className=''>{elemento.codigoCiudad}</td> */}
      </tr>
    )
  }
  if(opciones==="opcion3"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecurso}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(opciones==="opcion4"){
    return(
      <tr className=''>
        <td className=''>{elemento.nombreCiudad}</td>
        {opciones1==="opciones1_2" &&
          <td className=''>{elemento.nombreZona}</td>
        }
        <td className=''>{elemento.recaudoEn}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorDetalle.toString())}</td>
      </tr>
    )
  }  
  if(opciones==="opcion5_1"){
    return(
      <tr className=''>
        <td className=''>{elemento.nombreUsuario}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorDetalle.toString())}</td>
      </tr>
    )
  }  
  if(opciones==="opcion5"){
    return(
      <tr className=''>
        <td className='right aligned'>{general.formatNum(elemento.totPagos.toString())}</td>
        <td className=''>{elemento.fechaPago}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }  
  if(opciones==="opcion3_1"){
    return(
      <tr className=''>
        <td className='right aligned'>{general.formatNum(elemento.totPagos.toString())}</td>
        <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(opciones==="opcion6"&&!checkNoFactMPF){
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.razonSocial}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrDpto}</td>
        <td className=''>{elemento.nombreCiudad}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(opciones==="opcion6"&&checkNoFactMPF){
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.nombreCliente}</td>
        {/* <td className=''>{elemento.razonSocial}</td> */}
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrDpto}</td>
        <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.fechaPrimeraActivacion}</td>
        <td className=''>{elemento.estadoCliente}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(opciones==="opcion3_2"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.recaudoEn}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(opciones==="opcion3_3"){
    return(
      <tr className=''>
        <td className=''>{elemento.recaudoEn}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
};

const ListaRdo = ({list, opciones, opciones1, checkNoFactMPF}) => {
  const nivel1Detalle = list.map((elemento, i) => <RdoDet elemento={elemento} key={i} opciones={opciones} opciones1={opciones1} checkNoFactMPF={checkNoFactMPF}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const argsBuscarCL = {contrato: { $ne: "XXXYYYZZZ"}}

let argsBuscarPC = {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}

class RtesMovDi2 extends React.Component {
  state={argsDocum: {_id: "",  desde: "",  hasta: "", numeroDocum: "", descrRecurso: "Todo",
          descrOficina: "Todas...", usuarioCreate: "Todos...",
          descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...", nombreBarrio: "Todos...",
          descrClaseServ: "Todas...", checkNoFactMPF: false},
        opciones: (this.props.a150510===-1||sessionStorage.getItem('userLogin')==="foroptic@foroptic.com")?"opcion1":"opcion3",
        opciones1: "opciones1_1",
        listRtes: [], listaD: [], listaC: [], listaZ: [], listaB: [],
        totPag: 0, valorTot: 0, confirmaAct: false, open: false, errors: [],
        verEnPantalla: false}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsDocum = this.state.argsDocum
    if(ev.target.name === "tercero"){
      let miLista = document.getElementById("miLista5");
      if(miLista.options[miLista.selectedIndex].text==="Todo"||
          miLista.options[miLista.selectedIndex].text==="Pago en oficina"||
          miLista.options[miLista.selectedIndex].text==="Pago en App"||
          miLista.options[miLista.selectedIndex].text==="Tercero"){
        argsDocum['numeroDocum'] = ""
        argsDocum['descrRecurso'] = miLista.options[miLista.selectedIndex].text
      }else{
        argsDocum['numeroDocum'] = miLista.options[miLista.selectedIndex].attributes[0].value
        argsDocum['descrRecurso'] = miLista.options[miLista.selectedIndex].attributes[1].value
      }
    }else{
      if(ev.target.name==="opciones"){
        if(ev.target.checked===true){
          this.setState({opciones: ev.target.value})

          if(ev.target.value==="opcion1"||ev.target.value==="opcion6"||
              ev.target.value==="opcion3_2"||ev.target.value==="opcion3_3"||
              ev.target.value==="opcion7"){
            let descrClaseServ = document.getElementById("miLista4");
            if(descrClaseServ){
              descrClaseServ.options.selectedIndex = 0
            }
            let argsDocum = this.state.argsDocum
            argsDocum['descrClaseServ'] = "Todas..."
          }
        }
      }else{
        if(ev.target.name==="opciones1"){
          if(ev.target.checked===true){
            this.setState({opciones1: ev.target.value})
          }
        }else{
          if(ev.target.name==="desde"||ev.target.name==="hasta"){
            argsDocum[ev.target.name] = ev.target.value

            let desde = argsDocum.desde
            let hasta = argsDocum.hasta
            if(ev.target.name==="desde"){
              desde = ev.target.value
            }else{
              hasta = ev.target.value
            }
            argsBuscarPC = {tipoqry: `[
              {$match: {fechaPago: { $gte: new Date('${desde}'), $lte: new Date('${hasta}')}}},
              {$group: {_id: "$usuarioCreate"}},
              {$lookup: {from: 'usuarios', localField: '_id', foreignField: 'email', as: 'usuario'}},
              {$unwind: '$usuario'},
              {$sort: {'usuario.nombreUsuario': 1}},
              {$project: {_id: 0, nombreUsuario: '$usuario.nombreUsuario', usuarioCreate: "$_id"}},
            ]`}
            this.props.allPagoRtesGroup1.refetch(argsBuscarPC)
          }else{
            // console.log(ev.target.name, ev.target.checked)
            if(ev.target.name === "checkNoFactMPF"){
              // console.log(ev.target.name, ev.target.checked)
              argsDocum[ev.target.name] = ev.target.checked
            }else{
              // console.log(ev.target.name, ev.target.value)
              argsDocum[ev.target.name] = ev.target.value
            }
          }
        }
        // argsDocum[ev.target.name] = ev.target.value
      }
    }

    // if(ev.target.name==="desde"||ev.target.name==="hasta"){
    //   const argsBuscarPC = {fechaPago: { $gte: argsDocum.desde, $lte: argsDocum.hasta }}
      // console.log(argsBuscarPC)
    //   this.props.allPagoRtes.refetch(argsBuscarPC)
    // }

// console.log(argsDocum)
    let listRtes = []
    this.setState({listRtes, totPag: 0, valorTot: 0})
    this.setState({verEnPantalla: false})
    this.setState({argsDocum});

    // if(ev.target.name==="desde"){
    //   const argsBuscarPC = {fechaPago: { $gte: ev.target.value, $lte: argsDocum.hasta }}
    //   this.props.allPagoRtes.refetch(argsBuscarPC)
    // }
    // if(ev.target.name==="hasta"){
    //   const argsBuscarPC = {fechaPago: { $gte: argsDocum.desde, $lte: ev.target.value }}
    //   this.props.allPagoRtes.refetch(argsBuscarPC)
    // }
  }

  handleSubmit = async (ev, argsDocum, opciones, opciones1, a150520)=>{
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let targetName = ev.target.name
    // console.log(opciones, opciones1)
    document.body.style.cursor = 'wait'

    if(targetName==="pantalla"||targetName==="pdf"){
      this.setState({verEnPantalla: true})
    } 
    if((targetName==="pantalla"&&this.state.listRtes.length===0)||this.state.listRtes.length===0){
    // if(targetName==="pantalla"){
    let argsUpd
    let errors = []
    // if(!this.props.allPagoRtes.allPagoRtes){
    //   errors.push({path: "Mov diario", message: "Proceso de cargue de la información, por favor espere un momento..."});
    // }
    if(!this.props.allPagoRtes.allPagoRtes){
      errors.push({path: "Mov diario", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }
    if(!this.state.argsDocum.desde){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial del reporte"});
    }
    if(!this.state.argsDocum.hasta){
        errors.push({path: "Hasta", message: "Debe seleccionar la fecha final del reporte"});
      }
  
    // console.log(this.state.argsDocum)
    // console.log(argsDocum)
    this.setState({errors})
    if(errors.length===0){
      //Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
      let argsBuscarPC="", argsBuscarPCCl=""
      // console.log(argsDocum.descrDpto)
      // if(!argsDocum.descrDpto){
      //   console.log(argsDocum.descrDpto)
      // }
      if(argsDocum.cicloFact&&argsDocum.cicloFact!=="Todos..."){
        if(argsBuscarPCCl){argsBuscarPCCl += `, `}
        argsBuscarPCCl += `'cliente.cicloFact': '${argsDocum.cicloFact}'`
      }
      // if(!argsDocum.descrDpto||argsDocum.descrDpto==="Todos..."){

      // }else{
      //   if(!argsDocum.nombreCiudad||argsDocum.nombreCiudad==="Todas..."){
      //     if(argsBuscarPCCl){argsBuscarPCCl += `, `}
      //     argsBuscarPCCl += `'cliente.dirmayor.descrDpto': '${argsDocum.descrDpto}'`
      //   }else{
      //     if(!argsDocum.nombreZona||argsDocum.nombreZona==="Todas..."){
      //       if(argsBuscarPCCl){argsBuscarPCCl += `, `}
      //         argsBuscarPCCl += `'cliente.dirmayor.descrDpto': '${argsDocum.descrDpto}', 
      //           'cliente.dirmayor.ciudades.nombreCiudad': '${argsDocum.nombreCiudad}'`
      //     }else{
      //       if(!argsDocum.nombreBarrio||argsDocum.nombreBarrio==="Todos..."){
      //         if(argsBuscarPCCl){argsBuscarPCCl += `, `}
      //           argsBuscarPCCl += `'cliente.dirmayor.descrDpto': '${argsDocum.descrDpto}', 
      //             'cliente.dirmayor.ciudades.nombreCiudad': '${argsDocum.nombreCiudad}', 
      //             'cliente.dirmayor.ciudades.zonas.nombreZona': '${argsDocum.nombreZona}'`
      //       }else{
      //         if(argsBuscarPCCl){argsBuscarPCCl += `, `}
      //           argsBuscarPCCl += `'cliente.dirmayor.descrDpto': '${argsDocum.descrDpto}', 
      //             'cliente.dirmayor.ciudades.nombreCiudad': '${argsDocum.nombreCiudad}', 
      //             'cliente.dirmayor.ciudades.zonas.nombreZona': '${argsDocum.nombreZona}', 
      //             'cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio': '${argsDocum.nombreBarrio}'`
      //       }
      //     }
      //   }
      // }

// console.log(this.props.allPagoRtes.allPagoRtes)
// console.log(this.state.argsDocum)
// console.log(opciones)
      if(opciones==="opcion7"){
        argsBuscarPC += `fechaPago: { $gte: new Date('${this.state.argsDocum.desde}'), $lte: new Date('${this.state.argsDocum.hasta}') }, 
        'documento': {$eq: 'ANULADO'}`
      }else{
        argsBuscarPC += `fechaPago: { $gte: new Date('${this.state.argsDocum.desde}'), $lte: new Date('${this.state.argsDocum.hasta}') }, 
        'documento': {$ne: 'ANULADO'}`
      }





      if(!argsDocum.descrDpto||argsDocum.descrDpto==="Todos..."){

      }else{
        if(!argsDocum.nombreCiudad||argsDocum.nombreCiudad==="Todas..."){
          if(argsBuscarPC){argsBuscarPC += `, `}
          argsBuscarPC += `'descrDpto': '${argsDocum.descrDpto}'`
        }else{
          if(!argsDocum.nombreZona||argsDocum.nombreZona==="Todas..."){
            if(argsBuscarPC){argsBuscarPC += `, `}
              argsBuscarPC += `'descrDpto': '${argsDocum.descrDpto}', 
                'nombreCiudad': '${argsDocum.nombreCiudad}'`
          }else{
            if(!argsDocum.nombreBarrio||argsDocum.nombreBarrio==="Todos..."){
              if(argsBuscarPC){argsBuscarPC += `, `}
                argsBuscarPC += `'descrDpto': '${argsDocum.descrDpto}', 
                  'nombreCiudad': '${argsDocum.nombreCiudad}', 
                  'nombreZona': '${argsDocum.nombreZona}'`
            }else{
              if(argsBuscarPC){argsBuscarPC += `, `}
                argsBuscarPC += `'descrDpto': '${argsDocum.descrDpto}', 
                  'nombreCiudad': '${argsDocum.nombreCiudad}', 
                  'nombreZona': '${argsDocum.nombreZona}', 
                  'nombreBarrio': '${argsDocum.nombreBarrio}'`
            }
          }
        }
      }





      // console.log(this.state.argsDocum.descrClaseServ)
      if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."&&
          opciones!=="opcion1"&&opciones!=="opcion7"){
        argsBuscarPC += `, `
        argsBuscarPC += `'detalle.descrClaseServ': '${this.state.argsDocum.descrClaseServ}'`
      }

      let miLista = document.getElementById("miListaOf");
      if(miLista.options[miLista.selectedIndex].text!=="Todas..."){
        argsBuscarPC += `, `
        argsBuscarPC += `'descrOficina': '${miLista.options[miLista.selectedIndex].text}'`
      }

      // if(a150520===-1||sessionStorage.getItem('userLogin')==="foroptic@foroptic.com"){
        miLista = document.getElementById("miLista6");
        if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          // console.log(miLista.options[miLista.selectedIndex].text)
          // console.log(miLista.options[miLista.selectedIndex].attributes[0].value)
          // console.log(miLista.options[miLista.selectedIndex].attributes[1].value)
    
          argsBuscarPC += `, `
          argsBuscarPC += `'usuarioCreate': '${miLista.options[miLista.selectedIndex].attributes[0].value}'`
        }
      // }

      if(a150520!==-1&&sessionStorage.getItem('userLogin')!=="foroptic@foroptic.com"){
        argsBuscarPC += `, `
        // argsBuscarPC += `'descrRecurso': null`
        argsBuscarPC += `'descripcionPago': {$in: ['Pago en oficina', 'Otros pagos del cliente']}`
      }else{
        miLista = document.getElementById("miLista5");
        if(miLista.options[miLista.selectedIndex].text!=="Todo"){
          if(miLista.options[miLista.selectedIndex].text==="Pago en oficina"){
            argsBuscarPC += `, `
            // argsBuscarPC += `'descrRecurso': null`
            argsBuscarPC += `'descripcionPago': {$in: ['Pago en oficina', 'Otros pagos del cliente']}`
          }else{
            if(miLista.options[miLista.selectedIndex].text==="Pago en App"){
              argsBuscarPC += `, `
              argsBuscarPC += `'descripcionPago': 'Pago en App'`
            }else{
              if(miLista.options[miLista.selectedIndex].text==="Tercero"){
                argsBuscarPC += `, `
                argsBuscarPC += `'descripcionPago': {$nin: ['Pago en App', 'Pago en oficina', 'Otros pagos del cliente']}`
              }else{
                argsBuscarPC += `, `
                argsBuscarPC += `'numeroDocum': '${miLista.options[miLista.selectedIndex].attributes[0].value}'`
              }
            }
          }
        }
      }

let listRtes = []
let totPag = 0, valorTot = 0
// console.log(totPag, valorTot)
let movimRdo = []
argsBuscarPC = '{' + argsBuscarPC + '}'

//Traer el total de pagos
// console.log(argsBuscarPC)
let totPargsBuscarPC = {tipoqry: `[{$match: ${argsBuscarPC}},
  {$group: {_id: 1, saldoPendiente: { $sum: 1 }}},
  {$project: {_id: 0, saldoPendiente: '$saldoPendiente'}}]`}
if(this.props.allPagoRtes.allPagoRtes){
  // console.log(totPargsBuscarPC)
  let {data} = await this.props.allPagoRtes.refetch(totPargsBuscarPC)
  if(data!==undefined){
    if(data.allPagoRtes.length>0){
      totPag = await data.allPagoRtes[0].saldoPendiente
    }
  }
}
// console.log(totPag)
let tipoqry = `[{$match: ${argsBuscarPC}},`

// console.log(tipoqry)
let tieneargsBuscarPCCl = false
if(argsBuscarPCCl){
  tieneargsBuscarPCCl = true
  argsBuscarPCCl = '{' + argsBuscarPCCl + '}'
  if(opciones!=="opcion5"&&opciones!=="opcion3_1"){
    if(opciones==="opcion6"){
      // argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}, {$match: ${argsBuscarPCCl}},
      //     {$group: {_id: "$contrato", valorTotal: {$sum: "$valorTotal"}}},{$sort: {_id: 1}},
      //     {$project: {_id: 0, contrato: "$_id", valorTotal: "$valorTotal"}}  
      //   ]`}
      if(!argsDocum.checkNoFactMPF){
        //Se quita {$project: {_id: 0, contrato: "$_id", valorTotal: "$valorTotal"}} porque si se deja se repite el primer docummento
        argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: {contrato: "$contrato", descrDpto: "$descrDpto", nombreCiudad: "$nombreCiudad", nombreBarrio: "$nombreBarrio"}, valorTotal: {$sum: "$valorTotal"}}},
          {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrDpto', '$_id.nombreCiudad', '$_id.nombreBarrio']}, contrato: '$_id.contrato', descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', nombreBarrio: '$_id.nombreBarrio',
              valorTotal: {$toLong: '$valorTotal'}
          }},        
          {$sort: {_id: 1}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}, {$match: ${argsBuscarPCCl}}
        ]`}
      }else{
        argsBuscarPC = {tipoqry: `${tipoqry}
            {$unwind: '$detalle'},
            {$group: {_id: {contrato: '$contrato', descrDpto: "$descrDpto", nombreCiudad: "$nombreCiudad", nombreBarrio: "$nombreBarrio", descrRecurso: '$detalle.descrClaseServ', descripcionPago: '$detalle.descripcionServicio'},
                valorTotal: {$sum: "$detalle.valorDetalle"}}},
            {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrDpto', '$_id.nombreCiudad', '$_id.nombreBarrio', '$_id.descrRecurso', '$_id.descripcionPago']}, contrato: '$_id.contrato', descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', nombreBarrio: '$_id.nombreBarrio',
                descrRecurso: '$_id.descrRecurso', descripcionPago: '$_id.descripcionPago',
                valorTotal: {$toLong: '$valorTotal'}
            }},
            {$sort: {_id: 1}},
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
            {$match: ${argsBuscarPCCl}}
        ]`}
      }
      // console.log(argsBuscarPC)
    }else{
      if(opciones==="opcion3_2"){
        argsBuscarPC = {tipoqry: `${tipoqry}
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$match: ${argsBuscarPCCl}},
          {$unwind:"$cliente"},
          {$project: {
              'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "$descrRecurso", else: "Oficina" } },
              'descrRecursoR': '$cliente.dirmayor.ciudades.zonas.barrios.descrRecursoR', 'valorTotal': '$valorTotal'}},
          {$group: {_id: {descrRecursoR: '$descrRecursoR', recaudoEn: '$recaudoEn'}, valorTotal: {$sum: '$valorTotal'}}},
          {$unwind:"$_id"},
          {$sort: {_id: 1}},
          {$project: {_id: 0, 'descrRecurso': '$_id.descrRecursoR', 'recaudoEn': '$_id.recaudoEn', valorTotal: {$toLong: '$valorTotal'}}}
        ]`}
        if(this.props.allPagoRtesGroup.allPagoRtesGroup){
          let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
          movimRdo = await data.allPagoRtesGroup
        }
      }else{
        if(opciones==="opcion3_3"){
          argsBuscarPC = {tipoqry: `${tipoqry}
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
            {$match: ${argsBuscarPCCl}},
            {$unwind: "$detalle"},
            {$project: {idMovClientes: {$cond: { if: { $ifNull: [ "$detalle.idMovClientes", false ] }, then: {$toObjectId: '$detalle.idMovClientes'}, else: "" } },
                descripcionServicio: '$detalle.descripcionServicio', valorTotal: '$detalle.valorDetalle'}},
            {$lookup: {from: 'movclientes', localField: 'idMovClientes', foreignField: '_id', as: 'movim'}},
            {$project: {descripcionServicio: 1, valorTotal: 1,
                'movim': {
                 $cond: { if: { $eq: [ { $size: '$movim' }, 0 ] },
                    then: [{origen: "$descripcionServicio", subTipo: "CF"}],
                    else: "$movim"} 
                }
            }},
            {$unwind: "$movim"},
            {$project: {descripcionServicio: 1, valorTotal: 1, subTipo: "$movim.subTipo",
                origen: {
                 $cond: { if: { $eq: [ "$movim.subTipo", "AP" ] },
                    then: "Ajuste Positivo",
                    else: "$movim.origen"} 
                }
            }},
            {$project: {descripcionServicio: 1, valorTotal: 1,
                origen: {
                 $cond: { if: { $eq: [ "$subTipo", "ND" ] },
                    then: "Nota Debito",
                    else: "$origen"} 
                }
            }},
            {$group: {_id: {origen: '$origen'}, valorTotal: {$sum: '$valorTotal'}}},
            {$project: {recaudoEn: '$_id.origen', valorTotal: 1}},
            {$sort: {recaudoEn: 1}}
          ]`}
          if(this.props.allPagoRtesGroup.allPagoRtesGroup){
            let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
            movimRdo = await data.allPagoRtesGroup
          }
        }else{
          if(opciones==="opcion4"){
            let argsBuscarPC1 = argsBuscarPC
            argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}, {$match: ${argsBuscarPCCl}},{$out : 'temprdos'}]`}
            if(this.props.allPagoRtesGroup.allPagoRtesGroup){
              await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
            }
            let tipoqry1 = `[{$match: ${argsBuscarPC1}},`
            argsBuscarPC = {tipoqry: `${tipoqry1} {$group: {_id: '$fechaPago', count: { $sum: 1 }}},
            {$project: {_id: 0, totPagos: {$toInt: '$count'}}}]`}
            if(this.props.allTempRdo.allTempRdo){
              let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
              movimRdo = await data.allTempRdo
              totPag = 0
              movimRdo.forEach((elemento1, i) => {
                totPag += elemento1.totPagos
              })
            }
            tipoqry += ` {"$unwind":"$detalle"},`
            if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
              tipoqry += `{$match: {'detalle.descrClaseServ': '${this.state.argsDocum.descrClaseServ}'}},`
            }
      
            argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
              {$match: ${argsBuscarPCCl}},
              {$project: {
                'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
                'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle',
                'nombreCiudad': '$cliente.dirmayor.ciudades.nombreCiudad',
                'nombreZona': '$cliente.dirmayor.ciudades.zonas.nombreZona'}},
              {$unwind:"$nombreCiudad"},
              {$unwind:"$nombreZona"},
              {$group: {_id: {nombreCiudad: '$nombreCiudad',
                nombreZona: '${opciones1==="opciones1_1"?'$nombreCiudad':'$nombreZona'}',
                recaudoEn: '$recaudoEn', descrClaseServ: '$descrClaseServ'}, count: { $sum: 1 }, valorTotal: {$sum: '$valorTotal'}}},
              {$unwind:"$_id"},
              {$sort: {_id: 1}},
              {$project: {_id: {$concat: ['$_id.nombreCiudad', '$_id.nombreZona', '$_id.recaudoEn', '$_id.descrClaseServ']},
                'contrato': '$_id.nombreCiudad', 'documento': '$_id.nombreZona',
                'descrRecurso': '$_id.recaudoEn', 'descripcionPago': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
            ]`}
          }else{
            argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
              {$match: ${argsBuscarPCCl}},
              {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
              {$unwind: '$usuario'},
            ]`}
          }
        }
      } 
    }
    // console.log(argsBuscarPC)
    // argsBuscarPC += {tipoqry: `${tipoqry} {$group: {_id: "$contrato", valorTotal: {$sum: "$valorTotal"}}},{$sort: {_id: 1}},
    // {$project: {_id: 0, contrato: "$_id", valorTotal: "$valorTotal"}}]`}
  }else{
    // console.log(argsBuscarPC)
    let argsBuscarPC1 = argsBuscarPC
    argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}, {$match: ${argsBuscarPCCl}},{$out : 'temprdos'}]`}
    if(this.props.allPagoRtesGroup.allPagoRtesGroup){
      await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
      // console.log(argsBuscarPC)
    }
    tipoqry = `[{$match: ${argsBuscarPC1}},`
    // console.log(tipoqry)
    if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
      // if(opciones==="opcion5"){
        argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: '$fechaPago', count: { $sum: 1 }, valorTotal: {$sum: '$valorTotal'}}},{$sort: {_id: 1}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'}, fechaPago: {$dateToString: {format: '%Y-%m-%d', date: '$_id'}}, valorTotal: '$valorTotal'}}]`}
      // }
      if(this.props.allTempRdo.allTempRdo){
        // console.log(argsBuscarPC)
        let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
        movimRdo = await data.allTempRdo
        totPag = 0
        movimRdo.forEach((elemento1, i) => {
          totPag += elemento1.totPagos
        })
      }
      
      if(opciones==="opcion3_1"){
        argsBuscarPC = {tipoqry: `${tipoqry} {$project : { contrato: 1, numeroRC: 1, descrClaseServ : '$detalle.descrClaseServ', valorTotal : '$valorTotal',
              nombreCiudad : '$nombreCiudad',
              nombreBarrio : '$nombreBarrio', _id : 0 }},
          {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$descrClaseServ', nombreCiudad: '$nombreCiudad', nombreBarrio: '$nombreBarrio'},
              valorTotal: {$sum: '$valorTotal'}}},
          {$group : {_id : {nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio", descrClaseServ : '$_id.descrClaseServ'}, count: { $sum: 1 },
              valorTotal: {$sum: '$valorTotal'}}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'},
              nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ', valorTotal: '$valorTotal'}}]`}
          }

      tipoqry += ` {"$unwind":"$detalle"},`
      if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
        tipoqry += `{$match: {'detalle.descrClaseServ': '${this.state.argsDocum.descrClaseServ}'}},`
      }
      if(opciones==="opcion5"){
        argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: '$fechaPago', count: { $sum: 1 }, valorTotal: {$sum: '$detalle.valorDetalle'}}},{$sort: {_id: 1}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'}, fechaPago: {$dateToString: {format: '%Y-%m-%d', date: '$_id'}}, valorTotal: '$valorTotal'}}]`}
      }else{
        argsBuscarPC = {tipoqry: `${tipoqry} 
          {$project : { contrato: 1, numeroRC: 1, descrClaseServ : '$detalle.descrClaseServ', valorDetalle : '$detalle.valorDetalle',
              nombreCiudad : '$nombreCiudad',
              nombreBarrio : '$nombreBarrio', _id : 0 }},
          {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$descrClaseServ',
              nombreCiudad: "$nombreCiudad", nombreBarrio: '$nombreBarrio'},
              valorTotal: {$sum: '$valorDetalle'}}},
          {$group : {_id : {nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ'}, count: { $sum: 1 },
              valorTotal: {$sum: '$valorTotal'}}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'},
              nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ', valorTotal: '$valorTotal'}}]`}
      }
      if(this.props.allTempRdo.allTempRdo){
        // console.log(argsBuscarPC)
        let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
        movimRdo = await data.allTempRdo
      }
    }else{
      // if(opciones==="opcion5"){
        argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: '$fechaPago', count: { $sum: 1 }, valorTotal: {$sum: '$valorTotal'}}},{$sort: {_id: 1}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'}, fechaPago: {$dateToString: {format: '%Y-%m-%d', date: '$_id'}}, valorTotal: '$valorTotal'}}]`}
      // }
      let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
      movimRdo = await data.allTempRdo
      totPag = 0
      movimRdo.forEach((elemento1, i) => {
        totPag += elemento1.totPagos
      })
      // console.log(totPag, argsBuscarPC)
      
      if(opciones==="opcion3_1"){
        argsBuscarPC = {tipoqry: `${tipoqry} {"$unwind":"$detalle"},
          {$project : { contrato: 1, numeroRC: 1, descrClaseServ : '$detalle.descrClaseServ', valorDetalle : '$detalle.valorDetalle',
          nombreCiudad: '$nombreCiudad',
          nombreBarrio: '$nombreBarrio', _id : 0 }},
          {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$descrClaseServ',
              nombreCiudad: '$nombreCiudad', nombreBarrio: '$nombreBarrio'},
              valorTotal: {$sum: '$valorDetalle'}}},
          {$group : {_id : {nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ'}, count: { $sum: 1 },
              valorTotal: {$sum: '$valorTotal'}}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'},
              nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ', valorTotal: '$valorTotal'}},
          {$sort: {nombreCiudad: 1, nombreBarrio: 1, descrClaseServ: 1}}]`}
          // console.log(argsBuscarPC)
        let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
        movimRdo = await data.allTempRdo
      }
    }
    // }
    // if(opciones==="opcion6"){
    //   argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: "$contrato", valorTotal: {$sum: "$valorTotal"}}},{$sort: {_id: 1}},
    //     {$project: {_id: 0, contrato: "$_id", totPagos: { $sum: 1 }, valorTotal: "$valorTotal"}}]`}
    //   let {data} = await this.props.allTempRdo.refetch(argsBuscarPC)
    //   movimRdo = await data.allTempRdo
    //   totPag = 0
    //   movimRdo.forEach((elemento1, i) => {
    //     totPag += elemento1.totPagos
    //   })
    // }
  }
}else{
  if(opciones!=="opcion5"&&opciones!=="opcion3_1"){
    if(opciones!=="opcion4"&&opciones!=="opcion5_1"){
      if(opciones==="opcion6"){
        if(!argsDocum.checkNoFactMPF){
          //Se quita {$project: {_id: 0, contrato: "$_id", valorTotal: "$valorTotal"}} porque si se deja se repite el primer docummento
          argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: {contrato: "$contrato", descrDpto: "$descrDpto", nombreCiudad: "$nombreCiudad", nombreBarrio: "$nombreBarrio"}, valorTotal: {$sum: "$valorTotal"}}},
            {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrDpto', '$_id.nombreCiudad', '$_id.nombreBarrio']}, contrato: '$_id.contrato', descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', nombreBarrio: '$_id.nombreBarrio',
                valorTotal: {$toLong: '$valorTotal'}
            }},
            {$sort: {_id: 1}},
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}
          ]`}
        }else{
          argsBuscarPC = {tipoqry: `${tipoqry}
            {$unwind: '$detalle'},
            {$group: {_id: {contrato: '$contrato', descrDpto: "$descrDpto", nombreCiudad: "$nombreCiudad", nombreBarrio: "$nombreBarrio", descrRecurso: '$detalle.descrClaseServ', descripcionPago: '$detalle.descripcionServicio'},
                valorTotal: {$sum: "$detalle.valorDetalle"}}},
            {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrDpto', '$_id.nombreCiudad', '$_id.nombreBarrio', '$_id.descrRecurso', '$_id.descripcionPago']}, contrato: '$_id.contrato', descrDpto: '$_id.descrDpto', nombreCiudad: '$_id.nombreCiudad', nombreBarrio: '$_id.nombreBarrio',
                descrRecurso: '$_id.descrRecurso', descripcionPago: '$_id.descripcionPago',
                valorTotal: {$toLong: '$valorTotal'}
            }},
            {$sort: {_id: 1}},
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}
          ]`}
        }
        // console.log(argsBuscarPC)
      }else{
        if(opciones==="opcion3_2"){
          argsBuscarPC = {tipoqry: `${tipoqry}
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
            {$unwind:"$cliente"},
            {$project: {
                'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "$descrRecurso", else: "Oficina" } },
                'descrRecursoR': '$cliente.dirmayor.ciudades.zonas.barrios.descrRecursoR', 'valorTotal': '$valorTotal'}},
            {$group: {_id: {descrRecursoR: '$descrRecursoR', recaudoEn: '$recaudoEn'}, valorTotal: {$sum: '$valorTotal'}}},
            {$unwind:"$_id"},
            {$sort: {_id: 1}},
            {$project: {_id: 0, 'descrRecurso': '$_id.descrRecursoR', 'recaudoEn': '$_id.recaudoEn', valorTotal: {$toLong: '$valorTotal'}}}
          ]`}
          if(this.props.allPagoRtesGroup.allPagoRtesGroup){
            let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
            movimRdo = await data.allPagoRtesGroup
          }
        }else{
          if(opciones==="opcion3_3"){
            argsBuscarPC = {tipoqry: `${tipoqry}
              {$unwind: "$detalle"},
              {$project: {idMovClientes: {$cond: { if: { $ifNull: [ "$detalle.idMovClientes", false ] }, then: {$toObjectId: '$detalle.idMovClientes'}, else: "" } },
                  descripcionServicio: '$detalle.descripcionServicio', valorTotal: '$detalle.valorDetalle'}},
              {$lookup: {from: 'movclientes', localField: 'idMovClientes', foreignField: '_id', as: 'movim'}},
              {$project: {descripcionServicio: 1, valorTotal: 1,
                  'movim': {
                  $cond: { if: { $eq: [ { $size: '$movim' }, 0 ] },
                      then: [{origen: "$descripcionServicio", subTipo: "CF"}],
                      else: "$movim"} 
                  }
              }},
              {$unwind: "$movim"},
              {$project: {descripcionServicio: 1, valorTotal: 1, subTipo: "$movim.subTipo",
                  origen: {
                  $cond: { if: { $eq: [ "$movim.subTipo", "AP" ] },
                      then: "Ajuste Positivo",
                      else: "$movim.origen"} 
                  }
              }},
              {$project: {descripcionServicio: 1, valorTotal: 1,
                  origen: {
                  $cond: { if: { $eq: [ "$subTipo", "ND" ] },
                      then: "Nota Debito",
                      else: "$origen"} 
                  }
              }},
              {$group: {_id: {origen: '$origen'}, valorTotal: {$sum: '$valorTotal'}}},
              {$project: {recaudoEn: '$_id.origen', valorTotal: 1}},
              {$sort: {recaudoEn: 1}}
            ]`}
            if(this.props.allPagoRtesGroup.allPagoRtesGroup){
              let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
              movimRdo = await data.allPagoRtesGroup
            }
          }else{
            argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
              {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
              {$unwind: '$usuario'},
            ]`}
          }
        }
      }
    }else{
      // console.log("66")
      //opciones==="opcion4" => Resumen general
      tipoqry += ` {"$unwind":"$detalle"},`
      if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
        tipoqry += `{$match: {'detalle.descrClaseServ': '${this.state.argsDocum.descrClaseServ}'}},`
      }
      if(opciones==="opcion4"){
        if(opciones1==="opciones1_1"){
          // argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          //   {$project: {
          //     'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
          //     'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle',
          //     'nombreCiudad': '$cliente.dirmayor.ciudades.nombreCiudad'}},
          //   {$unwind:"$nombreCiudad"},
          //   {$group: {_id: {nombreCiudad: '$nombreCiudad',
          //     recaudoEn: '$recaudoEn', descrClaseServ: '$descrClaseServ'}, valorTotal: {$sum: '$valorTotal'}}},
          //   {$unwind:"$_id"},
          //   {$sort: {_id: 1}},
          //   {$project: {_id: 0, 'nombreBarrio': '$_id.nombreCiudad',
          //     'recaudoEn': '$_id.recaudoEn', 'descrClaseServ': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
          // ]`}

          argsBuscarPC = {tipoqry: `${tipoqry} 
            {$project: {
              'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
              'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle',
              'nombreCiudad': '$nombreCiudad'}},
            {$unwind:"$nombreCiudad"},
            {$group: {_id: {nombreCiudad: '$nombreCiudad',
              recaudoEn: '$recaudoEn', descrClaseServ: '$descrClaseServ'}, valorTotal: {$sum: '$valorTotal'}}},
            {$unwind:"$_id"},
            {$sort: {_id: 1}},
            {$project: {_id: 0, 'nombreBarrio': '$_id.nombreCiudad',
              'recaudoEn': '$_id.recaudoEn', 'descrClaseServ': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
          ]`}
        }else{
          // argsBuscarPC = {tipoqry: `${tipoqry} {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          //   {$project: {
          //     'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
          //     'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle',
          //     'nombreCiudad': '$cliente.dirmayor.ciudades.nombreCiudad',
          //     'nombreZona': '$cliente.dirmayor.ciudades.zonas.nombreZona'}},
          //   {$unwind:"$nombreCiudad"},
          //   {$unwind:"$nombreZona"},
          //   {$group: {_id: {nombreCiudad: '$nombreCiudad',
          //     nombreZona: '${opciones1==="opciones1_1"?'$nombreCiudad':'$nombreZona'}',
          //     recaudoEn: '$recaudoEn', descrClaseServ: '$descrClaseServ'}, valorTotal: {$sum: '$valorTotal'}}},
          //   {$unwind:"$_id"},
          //   {$sort: {_id: 1}},
          //   {$project: {_id: 0, 'nombreBarrio': '$_id.nombreCiudad', 'documento': '$_id.nombreZona',
          //     'recaudoEn': '$_id.recaudoEn', 'descrClaseServ': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
          // ]`}
        
          argsBuscarPC = {tipoqry: `${tipoqry} 
            {$project: {
              'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
              'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle',
              'nombreCiudad': '$nombreCiudad',
              'nombreZona': '$nombreZona'}},
            {$unwind:"$nombreCiudad"},
            {$unwind:"$nombreZona"},
            {$group: {_id: {nombreCiudad: '$nombreCiudad',
              nombreZona: '${opciones1==="opciones1_1"?'$nombreCiudad':'$nombreZona'}',
              recaudoEn: '$recaudoEn', descrClaseServ: '$descrClaseServ'}, valorTotal: {$sum: '$valorTotal'}}},
            {$unwind:"$_id"},
            {$sort: {_id: 1}},
            {$project: {_id: 0, 'nombreBarrio': '$_id.nombreCiudad', 'documento': '$_id.nombreZona',
              'recaudoEn': '$_id.recaudoEn', 'descrClaseServ': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
          ]`}
        }
        // console.log(argsBuscarPC)
      }
      if(opciones==="opcion5_1"){
        argsBuscarPC = {tipoqry: `${tipoqry}
          {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
          {$unwind: '$usuario'},
          {$project: {
            'nombreUsuario': '$usuario.nombreUsuario',
            'descrClaseServ': '$detalle.descrClaseServ', 'valorTotal': '$detalle.valorDetalle'}},
          {$group: {_id: {nombreUsuario: '$nombreUsuario', descrClaseServ: '$descrClaseServ'}, valorTotal: {$sum: '$valorTotal'}}},
          {$unwind:"$_id"},
          {$sort: {_id: 1}},
          {$project: {_id: 0, 'nombreUsuario': '$_id.nombreUsuario', 'descrClaseServ': '$_id.descrClaseServ', valorTotal: {$toLong: '$valorTotal'}}}
        ]`}
      }
      if(this.props.allPagoRtesGroup.allPagoRtesGroup){
        // console.log(argsBuscarPC)
        let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
        movimRdo = await data.allPagoRtesGroup
        // console.log(movimRdo.length)
      }
    }
  }else{
    // console.log("77")
    // if(opciones==="opcion5"){
    if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
      tipoqry += ` {"$unwind":"$detalle"},`
      tipoqry += `{$match: {'detalle.descrClaseServ': '${this.state.argsDocum.descrClaseServ}'}},`
      if(opciones==="opcion5"){
        argsBuscarPC = {tipoqry: `${tipoqry}
            {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$detalle.descrClaseServ', 
              fechaPago: '$fechaPago'}, valorTotal: {$sum: '$detalle.valorDetalle'}}},
            {"$unwind":"$_id"},
            {$project: {fechaPago: '$_id.fechaPago', valorTotal: '$valorTotal'}},
            {$group: {_id: '$fechaPago', count: { $sum: 1 }, valorTotal: {$sum: '$valorTotal'}}},
            {$sort: {_id: 1}},
            {$project: {_id: 0, totPagos: {$toInt: '$count'}, 
              fechaPago: {$dateToString: {format: '%Y-%m-%d', date: '$_id'}}, valorTotal: '$valorTotal'}}
          ]`}
      }else{
        argsBuscarPC = {tipoqry: `${tipoqry}
          {$project : { contrato: 1, numeroRC: 1, descrClaseServ : '$detalle.descrClaseServ', valorDetalle : '$detalle.valorDetalle',
              nombreCiudad: '$nombreCiudad',
              nombreBarrio: '$nombreBarrio', _id : 0 }},
          {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$descrClaseServ',
              nombreCiudad: '$nombreCiudad', nombreBarrio: '$nombreBarrio'},
              valorTotal: {$sum: '$valorDetalle'}}},
          {$group : {_id : {nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ'}, count: { $sum: 1 },
              valorTotal: {$sum: '$valorTotal'}}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'},
              documento: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio", descrClaseServ : '$_id.descrClaseServ', valorTotal: '$valorTotal'}},
          {$sort: {documento: 1, nombreBarrio: 1, descrClaseServ: 1}}
        ]`}
      }
      if(this.props.allPagoRtesGroup.allPagoRtesGroup){
        let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
        movimRdo = await data.allPagoRtesGroup
      }
    }else{
      if(opciones==="opcion5"){
        argsBuscarPC = {tipoqry: `${tipoqry} {$group: {_id: '$fechaPago', count: { $sum: 1 }, valorTotal: {$sum: '$valorTotal'}}},{$sort: {_id: 1}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'}, fechaPago: {$dateToString: {format: '%Y-%m-%d', date: '$_id'}}, valorTotal: '$valorTotal'}}]`}
      }else{
        argsBuscarPC = {tipoqry: `${tipoqry} {"$unwind":"$detalle"},
          {$project : { contrato: 1, numeroRC: 1, descrClaseServ : '$detalle.descrClaseServ', valorDetalle : '$detalle.valorDetalle',
          nombreCiudad : '$nombreCiudad',
          nombreBarrio : '$nombreBarrio', _id : 0 }},
          {$group: {_id: {numeroRC: '$numeroRC', descrClaseServ: '$descrClaseServ',
              nombreCiudad: '$nombreCiudad', nombreBarrio: '$nombreBarrio'},
              valorTotal: {$sum: '$valorDetalle'}}},
          {$group : {_id : {nombreCiudad: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ'}, count: { $sum: 1 },
              valorTotal: {$sum: '$valorTotal'}}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'},
              documento: "$_id.nombreCiudad", nombreBarrio: "$_id.nombreBarrio",
              descrClaseServ : '$_id.descrClaseServ', valorTotal: '$valorTotal'}},
          {$sort: {documento: 1, nombreBarrio: 1, descrClaseServ: 1}}]`}
        }
      // console.log(argsBuscarPC)
      let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
      movimRdo = await data.allPagoRtesGroup
    }
  }
}
// console.log(argsBuscarPC)
if(opciones!=="opcion5"&&opciones!=="opcion3_1"){
  if((opciones!=="opcion4"&&opciones!=="opcion5_1"&&opciones!=="opcion3_2"&&opciones!=="opcion3_3")||((opciones==="opcion4"||opciones==="opcion5_1")&&tieneargsBuscarPCCl)||opciones==="opcion6"){
    // console.log(argsBuscarPC)
    let {data} = await this.props.allPagoRtes.refetch(argsBuscarPC)
    if(data.allPagoRtes){
      movimRdo = await data.allPagoRtes
    }
    // console.log(movimRdo)
  }    
}

// console.log(movimRdo)
if((opciones==="opcion5_1")&&tieneargsBuscarPCCl){
  totPag = 0
}
if(tieneargsBuscarPCCl&&(opciones==="opcion1"||opciones==="opcion2"||opciones==="opcion3"||opciones==="opcion7")){
  totPag = movimRdo.length
}
// console.log(opciones)
  movimRdo.forEach((elemento1, i) => {
    // console.log(i)
    // console.log(clientesDX)
        // const indexSearch = clientesDX.findIndex( cliente => cliente.contrato===elemento1.contrato )
        // if(indexSearch!==-1){
        //   let elemento = clientesDX[indexSearch]

        if((opciones!=="opcion4"&&opciones!=="opcion5_1"&&opciones!=="opcion5"&&
            opciones!=="opcion3_1"&&opciones!=="opcion6"&&opciones!=="opcion3_2"&&opciones!=="opcion3_3")||
            ((opciones==="opcion5_1")&&tieneargsBuscarPCCl)){
          // ((opciones==="opcion4"||opciones==="opcion5_1")&&tieneargsBuscarPCCl)){
          let elemento = []
            elemento = elemento1.cliente[0]
          if(elemento){
          // clientesDX.forEach(async (elemento, _id) => {
          let cliPag = false
          // console.log(movimRdo)
          // console.log(elemento1)
          // movimRdo.forEach((elemento1, i) => {
          if(opciones!=="opcion2"&&opciones!=="opcion4"&&opciones!=="opcion5_1"){
            elemento1.detalle.forEach((elemento2, iii) => {
              // console.log(elemento2)
              // console.log(elemento1.razonap)
              //Validar si el servicio es de la clase seleccionada
              // if(!cliPag&&(!this.state.argsDocum.descrClaseServ||this.state.argsDocum.descrClaseServ==="Todas..."||
              //   (this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ===elemento2.descrClaseServ))){
              if(!cliPag){
                // console.log(elemento)
                argsUpd = {}
                if(opciones==="opcion1"||opciones==="opcion7"){
                  argsUpd = {
                    "fechaPago": elemento1.fechaCreate,
                    "descrRecurso": elemento1.descrRecurso,
                    "contrato": elemento.contrato,
                    "nombreCliente": elemento.nombreCliente,
                    "apellidoCliente": elemento.apellidoCliente,
                    "numeroRC": elemento1.numeroRC?elemento1.numeroRC:elemento1.numeroFra,
                    "numeroRT": elemento1.numeroRT,
                    "descrOficina": elemento1.descrOficina,
                    "valorTotal": elemento1.valorTotal,
                    "valorEf": elemento1.valorEf,
                    "valorCh": elemento1.valorCh,
                    "valorTr": elemento1.valorTr,
                    "valorTD": elemento1.valorTD,
                    "valorTC": elemento1.valorTC,
                    // "nombreBarrio": elemento.dirmayor&&elemento.dirmayor.codigoDpto?elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                    "nombreBarrio": elemento1.nombreBarrio?elemento1.nombreBarrio:"",
                    "usuarioCreate": elemento1.usuarioCreate,
                    "nombreUsuario": elemento1.usuario.nombreUsuario,
                    "razonap": elemento1.razonap
                    // "codigoZona": elemento.dirmayor&&elemento.dirmayor.codigoDpto?elemento.dirmayor.ciudades.zonas.codigoZona:"",
                    // "codigoCiudad": elemento.dirmayor&&elemento.dirmayor.codigoDpto?elemento.dirmayor.ciudades.codigoCiudad:"",
                  }
                  listRtes.push(argsUpd)

                  valorTot += elemento1.valorTotal
                  cliPag = true
                }else{
                  // console.log(elemento1)
                  // if(elemento1.descrRecurso){
                    if((this.state.argsDocum.descrClaseServ&&
                          this.state.argsDocum.descrClaseServ!=="Todas..."&&
                          elemento2.descrClaseServ===this.state.argsDocum.descrClaseServ)||
                          (!this.state.argsDocum.descrClaseServ||
                            this.state.argsDocum.descrClaseServ==="Todas...")){    
                      let descrRecurso = " Oficina"
                      if(elemento1.descrRecurso){
                        descrRecurso = elemento1.descrRecurso
                      }
                      argsUpd = {
                        "descrRecurso": descrRecurso,
                        "valorTotal": elemento2.valorDetalle,
                      }
                      listRtes.push(argsUpd)

                      valorTot += elemento2.valorDetalle
                      // cliPag = true
                    }
                  // }
                }
              }
            })
          }
          // console.log(elemento1)
          if(opciones==="opcion2"){
            elemento1.detalle.forEach((elemento2, i) => {
            //Validar si el servicio es de la clase seleccionada
            // if(!this.state.argsDocum.descrClaseServ||this.state.argsDocum.descrClaseServ==="Todas..."||
            //   (this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ===elemento2.descrClaseServ)){
              // if(!cliPag){
                if((this.state.argsDocum.descrClaseServ&&
                    this.state.argsDocum.descrClaseServ!=="Todas..."&&
                    elemento2.descrClaseServ===this.state.argsDocum.descrClaseServ)||
                    (!this.state.argsDocum.descrClaseServ||
                      this.state.argsDocum.descrClaseServ==="Todas...")){
                argsUpd = {}
                // console.log(elemento1)
                argsUpd = {
                  "recaudoEn": !elemento1.descrRecurso?"Oficina":"Tercero",
                  "fechaPago": elemento1.fechaCreate,
                  "descrRecurso": elemento1.descrRecurso,
                  "descrClaseServ": elemento2.descrClaseServ,
                  "descripcionServicio": elemento1.tipo==="PA "?"PA" + elemento2.descripcionServicio:elemento2.descripcionServicio,
                  "periodo": elemento2.periodo,
                  "contrato": elemento.contrato,
                  "nombreCliente": elemento.nombreCliente,
                  "apellidoCliente": elemento.apellidoCliente,
                  "numeroRC": elemento1.numeroRC?elemento1.numeroRC:elemento1.numeroFra,
                  "numeroRT": elemento1.numeroRT,
                  "valorDetalle": elemento2.valorDetalle,
                  // "nombreBarrio": elemento.dirmayor&&elemento.dirmayor.codigoDpto?elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                  "nombreBarrio": elemento1.nombreBarrio?elemento1.nombreBarrio:"",
                  "usuarioCreate": elemento1.usuarioCreate,
                  "nombreUsuario": elemento1.usuario.nombreUsuario,
                }
                listRtes.push(argsUpd)

                valorTot += elemento2.valorDetalle

                // if(!cliPag){valorTot += elemento1.valorTotal}
                cliPag = true
              }
              // }
            })
          }
          if(opciones==="opcion5_1"){
            elemento1.detalle.forEach((elemento2, i) => {
              //Validar si el servicio es de la clase seleccionada
              // if(!cliPag){
              if((this.state.argsDocum.descrClaseServ&&
                this.state.argsDocum.descrClaseServ!=="Todas..."&&
                elemento2.descrClaseServ===this.state.argsDocum.descrClaseServ)||
                (!this.state.argsDocum.descrClaseServ||
                  this.state.argsDocum.descrClaseServ==="Todas...")){
                argsUpd = {}
                argsUpd = {
                  "nombreUsuario": elemento1.usuario.nombreUsuario,
                  "descrClaseServ": elemento2.descrClaseServ,
                  "valorDetalle": elemento2.valorDetalle,
                }
                listRtes.push(argsUpd)
                // console.log(argsUpd)
                valorTot += elemento2.valorDetalle

                // if(!cliPag){valorTot += elemento1.valorTotal}
                cliPag = true
              // }
              }
            })
            if(cliPag){
              totPag += 1
            }
          }

          if(cliPag){
            // totPag += 1
          }
        // })
        }
      }else{
        if(opciones==="opcion4"){
          argsUpd = {}
          argsUpd = {
            "nombreCiudad": elemento1.nombreBarrio?elemento1.nombreBarrio:elemento1.contrato,
            "nombreZona": elemento1.documento,
            "recaudoEn": elemento1.recaudoEn?elemento1.recaudoEn:elemento1.descrRecurso,
            "descrClaseServ": elemento1.descrClaseServ?elemento1.descrClaseServ:elemento1.descripcionPago,
            "valorDetalle": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
        }
        if(opciones==="opcion5_1"){
          argsUpd = {}
          argsUpd = {
            "nombreUsuario": elemento1.nombreUsuario,
            "descrClaseServ": elemento1.descrClaseServ,
            "valorDetalle": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
        }
        if(opciones==="opcion5"){
        //TOTAL POR DIA
          argsUpd = {}
          argsUpd = {
            "totPagos": elemento1.totPagos,
            "fechaPago": elemento1.fechaPago,
            "valorTotal": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
          // totPag += elemento1.totPagos
        }
        if(opciones==="opcion3_1"){
        //TOTAL POR BARRIO
        // console.log(elemento1)
          argsUpd = {}
          argsUpd = {
            "totPagos": elemento1.totPagos,
            "nombreCiudad": elemento1.nombreCiudad?elemento1.nombreCiudad:elemento1.documento,
            "nombreBarrio": elemento1.nombreBarrio,
            "descrClaseServ": elemento1.descrClaseServ,
            "valorTotal": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
          // totPag += elemento1.totPagos
        }
        if(opciones==="opcion6"){
          //TOTAL POR CONTRATO
          let direccionCli = ""
          // console.log(elemento1)
          if(elemento1.cliente[0].direccion&&elemento1.cliente[0].direccion.descrTipoVia1){
            direccionCli = elemento1.cliente[0].direccion.descrTipoVia1?elemento1.cliente[0].direccion.descrTipoVia1:""
            direccionCli += elemento1.cliente[0].direccion.numeroTipoVia1?" " + elemento1.cliente[0].direccion.numeroTipoVia1:""
            direccionCli += elemento1.cliente[0].direccion.descrTipoVia2?" " + elemento1.cliente[0].direccion.descrTipoVia2:""
            direccionCli += elemento1.cliente[0].direccion.numeroTipoVia2?" " + elemento1.cliente[0].direccion.numeroTipoVia2:""
            direccionCli += elemento1.cliente[0].direccion.numeroTipoVia2F?" " + elemento1.cliente[0].direccion.numeroTipoVia2F:""
            direccionCli += elemento1.cliente[0].direccion.descrTipoUnd1?" " + elemento1.cliente[0].direccion.descrTipoUnd1:""
            direccionCli += elemento1.cliente[0].direccion.numeroTipoUnd1?" " + elemento1.cliente[0].direccion.numeroTipoUnd1:""
            direccionCli += elemento1.cliente[0].direccion.descrTipoUnd2?" " + elemento1.cliente[0].direccion.descrTipoUnd2:""
            direccionCli += elemento1.cliente[0].direccion.numeroTipoUnd2?" " + elemento1.cliente[0].direccion.numeroTipoUnd2:""
          }
          let razonSocial = elemento1.cliente[0].nombreCliente + " " + elemento1.cliente[0].apellidoCliente
          argsUpd = {}
          if(!argsDocum.checkNoFactMPF){
            argsUpd = {
              "contrato": elemento1.contrato,
              "codigoTipoDoc": elemento1.cliente[0].tipodoc.codigoTipoDoc,
              "numeroDoc": elemento1.cliente[0].numeroDoc,
              "apellidoCliente": elemento1.cliente[0].apellidoCliente,
              "nombreCliente": elemento1.cliente[0].nombreCliente,
              "razonSocial": razonSocial,
              "direccionCli": direccionCli,
              // "nombreBarrio": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
              // "codigoDpto": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.codigoDpto:"",
              // "codigoCiudad": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.ciudades.codigoCiudad:"",
              "nombreBarrio": elemento1.nombreBarrio?elemento1.nombreBarrio:"",
              "descrDpto": elemento1.descrDpto?elemento1.descrDpto:"",
              "nombreCiudad": elemento1.nombreCiudad?elemento1.nombreCiudad:"",
              "valorTotal": elemento1.valorTotal,
            }
          }else{
            argsUpd = {
              "contrato": elemento1.contrato,
              "codigoTipoDoc": elemento1.cliente[0].tipodoc.codigoTipoDoc,
              "numeroDoc": elemento1.cliente[0].numeroDoc,
              "apellidoCliente": elemento1.cliente[0].apellidoCliente,
              "nombreCliente": elemento1.cliente[0].nombreCliente,
              "razonSocial": razonSocial,
              "direccionCli": direccionCli,
              // "nombreBarrio": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
              // "codigoDpto": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.codigoDpto:"",
              // "codigoCiudad": elemento1.cliente[0].dirmayor&&elemento1.cliente[0].dirmayor.codigoDpto?elemento1.cliente[0].dirmayor.ciudades.codigoCiudad:"",
              "nombreBarrio": elemento1.nombreBarrio?elemento1.nombreBarrio:"",
              "descrDpto": elemento1.descrDpto?elemento1.descrDpto:"",
              "nombreCiudad": elemento1.nombreCiudad?elemento1.nombreCiudad:"",
              "fechaPrimeraActivacion": elemento1.cliente[0].fechaPrimeraActivacion?elemento1.cliente[0].fechaPrimeraActivacion.substring(0, 10):"",
              "estadoCliente": elemento1.cliente[0].estadoCliente,
              "descrClaseServ": elemento1.descrRecurso,
              "descripcionServicio": elemento1.descripcionPago,
              "valorTotal": elemento1.valorTotal,
            }
          }
          valorTot += elemento1.valorTotal
          // totPag += elemento1.totPagos
        }
        if(opciones==="opcion3_2"){
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento1.descrRecurso,
            "recaudoEn": elemento1.recaudoEn,
            "valorTotal": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
        }
        if(opciones==="opcion3_3"){
          argsUpd = {}
          argsUpd = {
            "recaudoEn": elemento1.recaudoEn,
            "valorTotal": elemento1.valorTotal,
          }
          valorTot += elemento1.valorTotal
        }

        listRtes.push(argsUpd)
      }
      })
      // console.log(listRtes.length)
      // console.log(listRtes)
// console.log("paso")
//       clientesDX = []
//       argsBuscarCL = {contrato: "XXXYYYZZZ"}
//       if(this.props.allCliBasico.allCliBasico){
//         let {data} = await this.props.allCliBasico.refetch(argsBuscarCL)
//         clientesDX = await data.allCliBasico
//       }
// console.log(clientesDX)

      if(opciones==="opcion3"){
//Agrupar por descrRecurso y sumar por valorTotal
        listRtes = _(listRtes)
          .groupBy('descrRecurso')
          .map((obj, key) => ({
            'descrRecurso': key,
            'valorTotal': _.sumBy(obj, 'valorTotal') }))
          .value()

//Ordenar por descrRecurso
        listRtes = _.orderBy(listRtes, ['descrRecurso'], ['asc'])
      }

      if(opciones==="opcion4"){
//Agrupar por recaudoEn + descrClaseServ y sumar por valorDetalle
        // let listRtesRte = _(listRtes)
        // .groupBy('nombreCiudad', 'recaudoEn', 'descrClaseServ')
        // .map((obj, key) => ({
        //     'nombreCiudad': key,
        //     'recaudoEn': _.groupBy(obj, 'recaudoEn'),
        //     'descrClaseServ': _.groupBy(obj, 'descrClaseServ')
        //   }))
        //   .value()

//         let listRtesRte1 = _(listRtes)
//         .groupBy('nombreCiudad', 'recaudoEn')
//         .map((obj, key) => ({
//             'nombreCiudad': key,
//             'recaudoEn': _.groupBy(obj, 'recaudoEn')
//           }))
//           .value()
// console.log(listRtesRte1)

// let listRtesRte2 = []
// listRtes.forEach(grupo => {
//   if (!listRtesRte2.find(cat => cat.nombreCiudad == grupo.nombreCiudad && cat.descrClaseServ == grupo.descrClaseServ)) {
//       const { nombreCiudad, recaudoEn, descrClaseServ } = grupo;
//       listRtesRte2.push({ nombreCiudad, recaudoEn, descrClaseServ });
//   }
// });

// let listRtesRte2 = _(listRtes)
// .groupBy('nombreCiudad', 'recaudoEn', 'descrClaseServ')
// .map((obj, key) => ({
//   'nombreCiudad': key,
//   'recaudoEn': obj[0].recaudoEn,
//   'descrClaseServ': obj[0].descrClaseServ,
// }))
// .value()
// console.log(listRtesRte2)

//         let listRtesRte = _(listRtes)
//         .groupBy('recaudoEn', 'descrClaseServ')
//         .map((obj, key) => ({
//             'recaudoEn': key,
//             'descrClaseServ': _.groupBy(obj, 'descrClaseServ')
//           }))
//           .value()

// console.log(listRtesRte)
//           listRtes = []
//           listRtesRte.forEach((elemento, _id) => {
//             Object.values(elemento.descrClaseServ).forEach((elemento1, i) => {
//               let totClase = 0
//               let clase = ""
//               elemento1.forEach((elemento2, ii) => {
//                 clase = elemento2.descrClaseServ
//                 totClase += elemento2.valorDetalle
//               })
//             argsUpd = {}
//             argsUpd = {
//               "recaudoEn": elemento.recaudoEn,
//               "descrClaseServ": clase,
//               "valorDetalle": totClase,
//             }
//             listRtes.push(argsUpd)
//           })
//         })
          // console.log(listRtes)

        // listRtes = _.orderBy(listRtes, ['recaudoEn', 'descrClaseServ'], ['asc', 'asc'])
        listRtes = _.orderBy(listRtes, ['nombreCiudad', 'recaudoEn', 'descrClaseServ'], ['asc', 'asc', 'asc'])
      }
      if(opciones==="opcion5_1"){
        //Agrupar por nombreUsuario + descrClaseServ y sumar por valorDetalle
        let listRtesRte = _(listRtes)
        .groupBy('nombreUsuario', 'descrClaseServ')
        .map((obj, key) => ({
            'nombreUsuario': key,
            'descrClaseServ': _.groupBy(obj, 'descrClaseServ')
          }))
          .value()

          listRtes = []
          listRtesRte.forEach((elemento, _id) => {
            Object.values(elemento.descrClaseServ).forEach((elemento1, i) => {
              let totClase = 0
              let clase = ""
              elemento1.forEach((elemento2, ii) => {
                clase = elemento2.descrClaseServ
                totClase += elemento2.valorDetalle
              })
            argsUpd = {}
            argsUpd = {
              "nombreUsuario": elemento.nombreUsuario,
              "descrClaseServ": clase,
              "valorDetalle": totClase,
            }
            listRtes.push(argsUpd)
          })
        })
          // console.log(listRtes)

        listRtes = _.orderBy(listRtes, ['nombreUsuario', 'descrClaseServ'], ['asc', 'asc'])
      }
        
      // console.log("DEMORA")
this.setState({listRtes})
this.setState({totPag})
this.setState({valorTot})
// console.log("FIN DEMORA")
      }
    }
    if(targetName==="pdf"){
      let doc = {}
      let left = 2
      let right = 2
      if(opciones==="opcion3"||opciones==="opcion4"||opciones==="opcion5_1"||opciones==="opcion5"||opciones==="opcion3_1"){
        doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        left = 30
        right = 30
      }else{
        doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      }
      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = "RECAUDO DIARIO"
      if(this.state.argsDocum.descrClaseServ&&this.state.argsDocum.descrClaseServ!=="Todas..."){
        texto2 = "RECAUDO DIARIO - " + this.state.argsDocum.descrClaseServ
      }
      let tit1Texto3 = argsDocum.desde
      let tit2Texto3 = argsDocum.hasta
      let texto3 = `${tit1Texto3} - ${tit2Texto3}`

      let widthDoc = (doc.internal.pageSize.width)
      doc.setFontSize(18);
      doc.setFontType("bold");
      doc.text(texto1, widthDoc/2, 20, 'center')
      doc.setFontSize(14);
      doc.text(texto2, widthDoc/2, 30, 'center')
      doc.text(texto3, widthDoc/2, 40, 'center')
      doc.setFontSize(10);

      if(opciones==="opcion3"||opciones==="opcion4"||opciones==="opcion5_1"||opciones==="opcion5"||opciones==="opcion3_1"){
        let movColecc = [], argsUpd = [], longMayor = 20
        let espacios = ""
        let encab
        this.state.listRtes.forEach((elemento, i) => {
          if(opciones==="opcion3"){
            if(elemento.descrRecurso.length>longMayor){
              longMayor = elemento.descrRecurso.length
            }
            argsUpd = [elemento.descrRecurso, general.formatNum(elemento.valorTotal.toString())]
            encab = ['Tercero', {content: "$ Total", styles: {halign: "right"}}]
          }
          if(opciones==="opcion4"){
            if(opciones1==="opciones1_1"){
              argsUpd = [elemento.nombreCiudad, elemento.recaudoEn, elemento.descrClaseServ, general.formatNum(elemento.valorDetalle.toString())]
              encab = ['Ciudad', 'Recaudo en', 'Clase', {content: "$ Total", styles: {halign: "right"}}]
            }else{
              argsUpd = [elemento.nombreCiudad, elemento.nombreZona, elemento.recaudoEn, elemento.descrClaseServ, general.formatNum(elemento.valorDetalle.toString())]
              encab = ['Ciudad', 'Zona', 'Recaudo en', 'Clase', {content: "$ Total", styles: {halign: "right"}}]
            }
          }
          if(opciones==="opcion5_1"){
            argsUpd = [elemento.nombreUsuario, elemento.descrClaseServ, general.formatNum(elemento.valorDetalle.toString())]
            encab = ['Usuario', 'Clase', {content: "$ Total", styles: {halign: "right"}}]
          }
          if(opciones==="opcion5"){
            argsUpd = [elemento.totPagos, elemento.fechaPago, general.formatNum(elemento.valorTotal.toString())]
            encab = ['Total pagos', 'Fecha', {content: "$ Total", styles: {halign: "right"}}]
          }
          if(opciones==="opcion3_1"){
            argsUpd = [elemento.totPagos, elemento.nombreCiudad, elemento.nombreBarrio, elemento.descrClaseServ, general.formatNum(elemento.valorTotal.toString())]
            encab = ['Total pagos', 'Ciudad', 'Barrio', 'Clase', {content: "$ Total", styles: {halign: "right"}}]
          }
          movColecc.push(argsUpd)
        })
        for(let ii=0; ii<longMayor; ii++){espacios += " "}
        if(opciones==="opcion3"){
          argsUpd = [espacios + "TOTAL:", general.formatNum(this.state.valorTot.toString())]
        }else{
          if(opciones==="opcion3_1"){
            argsUpd = ["", "", "", espacios + "TOTAL:", general.formatNum(this.state.valorTot.toString())]
          }else{
            if(opciones==="opcion4"){
              if(opciones1==="opciones1_1"){
                argsUpd = ["", "", espacios + "TOTAL:", general.formatNum(this.state.valorTot.toString())]
              }else{
                argsUpd = ["", "", "", espacios + "TOTAL:", general.formatNum(this.state.valorTot.toString())]
              }
            }else{
              argsUpd = ["", espacios + "TOTAL:", general.formatNum(this.state.valorTot.toString())]
            }
          }
        }
        movColecc.push(argsUpd)

        doc.autoTable({startY: 45,
          tableLineColor: "blue",
          tableLineWidth: 0.1,
          styles: {
            // font: 'Calibri',
            fontSize: 10,
            lineColor: "black",
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 12
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black"
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          columnStyles: {
            1: {halign: opciones==="opcion3"?"right":"left"},
            4: {halign: opciones!=="opcion3_1"?"right":"left"},
          },
          footStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          head: [encab],
          body: movColecc,
          // foot: foot,
          // margin: {top: 0, left: 10, right: 66},})
          margin: {top: 10, left: 10, right: 10},})
      }else{
        let fontSize_1 = 10
        let fontSize_2 = 12
        let styleCol = {}
        if(opciones==="opcion6"&&argsDocum.checkNoFactMPF){
          fontSize_1 = 6
          fontSize_2 = 6
          styleCol = {
            0: {cellWidth: 14},
            1: {cellWidth: 12},
            2: {cellWidth: 15.4},
            3: {cellWidth: 22},
            4: {cellWidth: 22},
            5: {cellWidth: 30},
            6: {cellWidth: 20},
            7: {cellWidth: 20},
            8: {cellWidth: 20},
            9: {cellWidth: 20},
            10: {cellWidth: 15},
            11: {cellWidth: 15},
            12: {cellWidth: 35},
            13: {cellWidth: 15},
          }
        }
        // console.log("pdf", opciones, argsDocum.checkNoFactMPF, fontSize_1, fontSize_2)
        var source = document.getElementById("tabla");
        doc.autoTable({startY: 45,
                        tableLineColor: "black",
                        tableLineWidth: 0.1,
                        styles: {
                          // font: 'Calibri',
                          fontSize: fontSize_1,
                          lineColor: "black",
                          lineWidth: 0.1,
                        },
                        headStyles: {
                          fillColor: "#bdc3c7",
                          textColor: "black",
                          fontSize: fontSize_2
                        },
                        bodyStyles: {
                          fillColor: "#E9E4F0",
                          textColor: "black"
                        },
                        columnStyles: styleCol,        
                        alternateRowStyles: {
                          fillColor: "white",
                          textColor: "black"
                        },
                        html: source,
                        margin: {top: 10, left: left, right: right},})  
      }

      // let nameDoc = `recaudo.pdf`
      // doc.autoPrint({variant: 'non-conform'});
      // doc.save(nameDoc)
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
      // => UTILIZAR
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
    }

    if(targetName==="excel"){
      // let xlsString = []
      let listRtes = this.state.listRtes
      // // console.log(listRtes)
      // let xlsString1 = []
      let sepCampos = "|"
      // if(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert"){
      if(targetName==="excel"){
        sepCampos = ";"
      }
      let txtString = ""
      if(opciones==="opcion1"||opciones==="opcion7"){
        if(opciones==="opcion7"){
          // xlsString1 = ['Fecha', 'Tercero', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Rbo Caja/Fra', 'Nodo',
          // '$ Total', '$ Ef', '$ Ch', '$ Transf', '$ TD', '$ TC', 'Barrio', 'Oficina', 'Razón']
          txtString += 'Fecha;Tercero;Contrato;Nombre(s);Apellido(s);Rbo Caja/Fra;Nodo;'
          txtString += '$ Total;$ Ef;$ Ch;$ Transf;$ TD;$ TC;Barrio;Oficina;Razón'
        }else{
          // xlsString1 = ['Fecha', 'Tercero', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Rbo Caja/Fra', 'Nodo',
          // '$ Total', '$ Ef', '$ Ch', '$ Transf', '$ TD', '$ TC', 'Barrio', 'Oficina', 'Digitado por']
          txtString += 'Fecha;Tercero;Contrato;Nombre(s);Apellido(s);Rbo Caja/Fra;Nodo;'
          txtString += '$ Total;$ Ef;$ Ch;$ Transf;$ TD;$ TC;Barrio;Oficina;Digitado por'
        }
      }
      if(opciones==="opcion2"){
        // xlsString1 = ['Fecha', 'Tercero', 'Clase', 'Concepto', 'Periodo', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Rbo Caja/Fra', 'Nodo',
        //   '$ Detalle', 'Barrio', 'Digitado por']
        txtString += 'Fecha;Tercero;Clase;Concepto;Periodo;Contrato;Nombre(s);Apellido(s);Rbo Caja/Fra;Nodo;'
        txtString += '$ Detalle;Barrio;Digitado por'
      }
      if(opciones==="opcion3"){
        // xlsString1 = ['Tercero', '$ Total']
        txtString += 'Tercero;$ Total'
      }
      if(opciones==="opcion4"){
        if(opciones1==="opciones1_1"){
          // xlsString1 = ['Ciudad', 'Recaudo en', 'Clase', '$ Total']
          txtString += 'Ciudad;Recaudo en;Clase;$ Total'
        }else{
          // xlsString1 = ['Ciudad', 'Zona', 'Recaudo en', 'Clase', '$ Total']
          txtString += 'Ciudad;Zona;Recaudo en;Clase;$ Total'
        }
      }
      if(opciones==="opcion5_1"){
        // xlsString1 = ['Usuario', 'Clase', '$ Total']
        txtString += 'Usuario;Clase;$ Total'
      }
      if(opciones==="opcion5"){
        // xlsString1 = ['Total pagos', 'Fecha', '$ Total']
        txtString += 'Total pagos;Fecha;$ Total'
      }
      if(opciones==="opcion3_1"){
        // xlsString1 = ['Total pagos', 'Ciudad', 'Barrio', 'Clase', '$ Total']
        txtString += 'Total pagos;Ciudad;Barrio;Clase;$ Total'
      }
      if(opciones==="opcion6"){
        if(!argsDocum.checkNoFactMPF){
          // xlsString1 = ['CONTRATO', 'TIPO DOCUM', 'No. DOCUM', 'APELLIDO(S)', 'NOMBRE(S)', 'RAZON SOCIAL', 'DIRECCION',
          // 'BARRIO', 'DPTO', 'CIUDAD', 'TOTAL PAGADO']
          txtString += 'CONTRATO;TIPO DOCUM;No. DOCUM;APELLIDO(S);NOMBRE(S);RAZON SOCIAL;DIRECCION;'
          txtString += 'BARRIO;DPTO;CIUDAD;TOTAL PAGADO'
        }else{
          // xlsString1 = ['CONTRATO', 'TIPO DOCUM', 'No. DOCUM', 'APELLIDO(S)', 'NOMBRE(S)', 'RAZON SOCIAL', 'DIRECCION',
          // 'BARRIO', 'DPTO', 'CIUDAD', 'PRIM ACTIVAC', 'ESTADO', 'CLASE', 'DETALLE PAGO', 'TOTAL PAGADO']
          txtString += 'CONTRATO;TIPO DOCUM;No. DOCUM;APELLIDO(S);NOMBRE(S);RAZON SOCIAL;DIRECCION;'
          txtString += 'BARRIO;DPTO;CIUDAD;PRIM ACTIVAC;ESTADO;CLASE;DETALLE PAGO;TOTAL PAGADO'
        }
      }
      if(opciones==="opcion3_2"){
        // xlsString1 = ['Tercero', 'Canal', '$ Total']
        txtString += 'Tercero;Canal;$ Total'
      }
      if(opciones==="opcion3_3"){
        // xlsString1 = ['Recaudado de', '$ Total']
        txtString += 'Recaudado de;$ Total'
      }
      // xlsString.push(xlsString1)
      txtString += "\r\n";

      for(let i=0; i<listRtes.length; i++){
        let fechaPago = "", descrRecurso = "", valorEf = 0, valorCh = 0, valorTr = 0, valorTD = 0, valorTC = 0
        if(listRtes[i].fechaPago){
          // fechaPago = new Date(listRtes[i].fechaPago)
          fechaPago = listRtes[i].fechaPago.substr(0, 10)
          // let horaPago = (fechaPago.getUTCHours()<10?'0'+fechaPago.getUTCHours():fechaPago.getUTCHours())+":"+(fechaPago.getUTCMinutes()<10?'0'+fechaPago.getUTCMinutes():fechaPago.getUTCMinutes())+":"+(fechaPago.getUTCSeconds()<10?'0'+fechaPago.getUTCSeconds():fechaPago.getUTCSeconds());
          let horaPago = listRtes[i].fechaPago.substr(11, 8)
          // fechaPago = (fechaPago.getUTCFullYear()) + '-' +
          //   ((fechaPago.getUTCMonth()+1)<10?'0'+(fechaPago.getUTCMonth()+1):(fechaPago.getUTCMonth()+1)) + '-' +
          //   (fechaPago.getUTCDate()<10?'0'+fechaPago.getUTCDate():fechaPago.getUTCDate())

          // if(horaPago==="00:00:00"){
          //   fechaPago = new Date(fechaPago + 'T23:00:00.000Z')
          // }else{
          //   fechaPago = new Date(fechaPago + 'T' + horaPago + 'Z')
          // }
          fechaPago += ' ' + horaPago
        }
        if(listRtes[i].descrRecurso){
          descrRecurso = listRtes[i].descrRecurso
        }
        if(listRtes[i].valorEf){
          valorEf = listRtes[i].valorEf
        }
        if(listRtes[i].valorCh){
          valorCh = listRtes[i].valorCh
        }
        if(listRtes[i].valorTr){
          valorTr = listRtes[i].valorTr
        }
        if(listRtes[i].valorTD){
          valorTD = listRtes[i].valorTD
        }
        if(listRtes[i].valorTC){
          valorTC = listRtes[i].valorTC
        }

        if(opciones==="opcion1"||opciones==="opcion7"){
          if(opciones==="opcion7"){
            txtString += fechaPago + sepCampos + descrRecurso + sepCampos + listRtes[i].contrato + sepCampos + listRtes[i].nombreCliente + sepCampos
            txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].numeroRC + sepCampos + listRtes[i].numeroRT + sepCampos + listRtes[i].valorTotal + sepCampos + valorEf + sepCampos
            txtString += valorCh + sepCampos + valorTr + sepCampos + valorTD + sepCampos + valorTC + sepCampos + listRtes[i].nombreBarrio + sepCampos + listRtes[i].descrOficina + sepCampos + listRtes[i].razonap
          }else{
            txtString += fechaPago + sepCampos + descrRecurso + sepCampos + listRtes[i].contrato + sepCampos + listRtes[i].nombreCliente + sepCampos
            txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].numeroRC + sepCampos + listRtes[i].numeroRT + sepCampos + listRtes[i].valorTotal + sepCampos + valorEf + sepCampos
            txtString += valorCh + sepCampos + valorTr + sepCampos + valorTD + sepCampos + valorTC + sepCampos + listRtes[i].nombreBarrio + sepCampos + listRtes[i].descrOficina + sepCampos + listRtes[i].nombreUsuario
          }
        }
        if(opciones==="opcion2"){
          txtString += fechaPago + sepCampos + descrRecurso + sepCampos + listRtes[i].descrClaseServ + sepCampos + listRtes[i].descripcionServicio + sepCampos
          txtString += listRtes[i].periodo + sepCampos + listRtes[i].contrato + sepCampos + listRtes[i].nombreCliente + sepCampos
          txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].numeroRC + sepCampos + listRtes[i].numeroRT + sepCampos + listRtes[i].valorDetalle + sepCampos
          txtString += listRtes[i].nombreBarrio + sepCampos + listRtes[i].nombreUsuario
        }
        if(opciones==="opcion3"){
          txtString += descrRecurso + sepCampos + listRtes[i].valorTotal
        }
        if(opciones==="opcion4"){
          if(opciones1==="opciones1_1"){
            // xlsString1 = [listRtes[i].nombreCiudad, listRtes[i].recaudoEn, listRtes[i].descrClaseServ, listRtes[i].valorDetalle]
            txtString += listRtes[i].nombreCiudad + sepCampos + listRtes[i].recaudoEn + sepCampos + listRtes[i].descrClaseServ + sepCampos + listRtes[i].valorDetalle
          }else{
            // xlsString1 = [listRtes[i].nombreCiudad, listRtes[i].nombreZona, listRtes[i].recaudoEn, listRtes[i].descrClaseServ, listRtes[i].valorDetalle]
            txtString += listRtes[i].nombreCiudad + sepCampos + listRtes[i].nombreZona + sepCampos + listRtes[i].recaudoEn + sepCampos + listRtes[i].descrClaseServ + sepCampos + listRtes[i].valorDetalle
          }
        }
        if(opciones==="opcion5_1"){
          // xlsString1 = [listRtes[i].nombreUsuario, listRtes[i].descrClaseServ, listRtes[i].valorDetalle]
          txtString += listRtes[i].nombreUsuario + sepCampos + listRtes[i].descrClaseServ + sepCampos + listRtes[i].valorDetalle
        }
        if(opciones==="opcion5"){
          // xlsString1 = [listRtes[i].totPagos, fechaPago, listRtes[i].valorTotal]
          txtString += listRtes[i].totPagos + sepCampos + fechaPago + sepCampos + listRtes[i].valorTotal
        }
        if(opciones==="opcion3_1"){
          // xlsString1 = [listRtes[i].totPagos, listRtes[i].nombreCiudad, listRtes[i].nombreBarrio, listRtes[i].descrClaseServ, listRtes[i].valorTotal]
          txtString += listRtes[i].totPagos + sepCampos + listRtes[i].nombreCiudad + sepCampos + listRtes[i].nombreBarrio + sepCampos + listRtes[i].descrClaseServ + sepCampos + listRtes[i].valorTotal
        }
        if(opciones==="opcion6"){
          if(!argsDocum.checkNoFactMPF){
            // xlsString1 = [listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc,
            //   listRtes[i].apellidoCliente, listRtes[i].nombreCliente,
            //   listRtes[i].razonSocial, listRtes[i].direccionCli, listRtes[i].nombreBarrio, 
            //   listRtes[i].descrDpto, listRtes[i].nombreCiudad, listRtes[i].valorTotal]
            txtString += listRtes[i].contrato + sepCampos + listRtes[i].codigoTipoDoc + sepCampos + listRtes[i].numeroDoc + sepCampos
            txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].nombreCliente + sepCampos
            txtString += listRtes[i].razonSocial + sepCampos + listRtes[i].direccionCli + sepCampos + listRtes[i].nombreBarrio + sepCampos
            txtString += listRtes[i].descrDpto + sepCampos + listRtes[i].nombreCiudad + sepCampos + listRtes[i].valorTotal
          }else{
            // xlsString1 = [listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc,
            //   listRtes[i].apellidoCliente, listRtes[i].nombreCliente,
            //   listRtes[i].razonSocial, listRtes[i].direccionCli, listRtes[i].nombreBarrio, 
            //   listRtes[i].descrDpto, listRtes[i].nombreCiudad, listRtes[i].fechaPrimeraActivacion,
            //   listRtes[i].estadoCliente, listRtes[i].descrClaseServ, listRtes[i].descripcionServicio,
            //   listRtes[i].valorTotal]
            txtString += listRtes[i].contrato + sepCampos + listRtes[i].codigoTipoDoc + sepCampos + listRtes[i].numeroDoc + sepCampos
            txtString += listRtes[i].apellidoCliente + sepCampos + listRtes[i].nombreCliente + sepCampos
            txtString += listRtes[i].razonSocial + sepCampos + listRtes[i].direccionCli + sepCampos + listRtes[i].nombreBarrio + sepCampos
            txtString += listRtes[i].descrDpto + sepCampos + listRtes[i].nombreCiudad + sepCampos + listRtes[i].fechaPrimeraActivacion + sepCampos
            txtString += listRtes[i].valorTotal
          }
        }
        if(opciones==="opcion3_2"){
          // xlsString1 = [listRtes[i].descrRecurso, listRtes[i].recaudoEn, listRtes[i].valorTotal]
          txtString += descrRecurso + sepCampos + listRtes[i].recaudoEn + sepCampos + listRtes[i].valorTotal
        }
        if(opciones==="opcion3_3"){
          // xlsString1 = [listRtes[i].recaudoEn, listRtes[i].valorTotal]
          txtString += listRtes[i].recaudoEn + sepCampos + listRtes[i].valorTotal
        }

    // console.log(xlsString1)
        // xlsString.push(xlsString1)
        txtString += "\r\n";
      }
  // console.log(xlsString)

//       var wb = XLSX.utils.book_new();

//       wb.Props = {
//         Title: "SheetJS Tutorial",
//         Subject: "Test",
//         Author: "Red Stapler",
//         CreatedDate: new Date(2017,12,19)
//       };

//       wb.SheetNames.push("Recaudo");

//       let ws_data = xlsString;

//       let ws = XLSX.utils.aoa_to_sheet(ws_data);
//       wb.Sheets["Recaudo"] = ws;
//       let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
//       function s2ab(s) { 
//         let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
//         let view = new Uint8Array(buf);  //create uint8array as viewer
//         for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
//         return buf;    
//       }
//       saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'recaudo.xlsx');
// //FIN Exportar a XLS

      var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
      // if(targetName==="excel"&&this.props.empresa.empresaArchFE==="codisert"){
      saveAs(blob, "recaudo.csv");
    }
    document.body.style.cursor = 'default'

    // console.log("listooooo")
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.desde===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['desde'] = fechaFechaHoy.substr(0,10)
      argsDocum['hasta'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      this.setState({listRtes: [], totCli: 0})
      this.setState({verEnPantalla: false})
    }

    if(this.props.allPagoRtesGroup1.allPagoRtesGroup&&prevProps.allPagoRtesGroup1.allPagoRtesGroup&&
        this.props.allPagoRtesGroup1.allPagoRtesGroup.length===0&&
        prevProps.allPagoRtesGroup1.allPagoRtesGroup.length===0){
      argsBuscarPC = {tipoqry: `[
        {$match: {fechaPago: { $gte: new Date('${this.state.argsDocum.desde}'), $lte: new Date('${this.state.argsDocum.hasta}')}}},
        {$group: {_id: "$usuarioCreate"}},
        {$lookup: {from: 'usuarios', localField: '_id', foreignField: 'email', as: 'usuario'}},
        {$unwind: '$usuario'},
        {$sort: {'usuario.nombreUsuario': 1}},
        {$project: {_id: 0, nombreUsuario: '$usuario.nombreUsuario', usuarioCreate: "$_id"}},
      ]`}
      await this.props.allPagoRtesGroup1.refetch(argsBuscarPC)
    }
  }

  componentWillUnmount(){
    let listRtes = []
    this.setState({listRtes, totPag: 0, valorTot: 0})
    this.setState({verEnPantalla: false})
  }

  render(){
    const {argsDocum, opciones, opciones1, listRtes, listaD, listaC,listaZ,listaB, totPag, valorTot,
      confirmaAct, open, errors, verEnPantalla} = this.state;
    const a150501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150501" );
    const a150505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150505" );
    const a150510 = this.props.a150510;
    const a150520 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150520" );
    const a150530 = this.props.autorizacUA.findIndex( autorizac => autorizac === "150530" );

    let listUserRdo = []
    if(a150520===-1||sessionStorage.getItem('userLogin')==="foroptic@foroptic.com"){
      if(this.props.allPagoRtesGroup1.allPagoRtesGroup){
        if(this.props.allPagoRtesGroup1.allPagoRtesGroup.length>0){
          this.props.allPagoRtesGroup1.allPagoRtesGroup.forEach((elemento, ii) => {
            listUserRdo.push({_id: ii, nombreUsuario: elemento.nombreUsuario, usuarioCreate: elemento.usuarioCreate})  
          })
        }
      }
    }else{
      let miListaDig = document.getElementById("miLista6");
      if(miListaDig){
        let items = miListaDig.children;
        let iii = 0
        for (let item of items) {
          if(item.textContent!=="Todos..."){
            let dato1 = item.getAttribute("dato1");
            listUserRdo.push({_id: iii, nombreUsuario: item.textContent, usuarioCreate: dato1})
            iii += 1
          }
        }
      }
      if(listRtes.length>0&&listUserRdo.length===0){
        let listRtesRte1 = _(listRtes)
          .groupBy('usuarioCreate', 'nombreUsuario')
          .map((obj, key) => ({
            'usuarioCreate': key,
            'nombreUsuario': obj[0].nombreUsuario,
          }))
          .value()

        listRtesRte1.forEach((elemento, ii) => {
          listUserRdo.push({_id: ii, nombreUsuario: elemento.nombreUsuario, usuarioCreate: elemento.usuarioCreate})  
        })
      }
      if(listRtes.length===0&&miListaDig&&miListaDig.options[miListaDig.selectedIndex].text==="Todos..."){
        listUserRdo = []
      }
    }
    // console.log(listUserRdo)

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        // console.log(this.props.list1)
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    // console.log(this.props.allPagoRtes.allPagoRtes)

    // console.log(this.props.allPagoRtes.allPagoRtes)
    // console.log(this.props.allServicios.allServicios)
// console.log(this.props.list)
// console.log(this.props.list1)
// console.log(argsDocum)
// console.log(opciones, this.props.a150510, sessionStorage.getItem('userLogin'))
// console.log(listaD, listaC, listaZ, listaB)
    let valorTotal = general.formatNum(valorTot.toString())
    let totalPagos = general.formatNum(totPag.toString())
    let totales = ""
    if(opciones!=="opcion6"){
      totales = "Totales:    Pagos: " + totalPagos + "    Valor: " + valorTotal
    }else{
      totales = "Totales:    Valor: " + valorTotal
    }

    let tipoArch = "ARCHIVO EXCEL"
    // if(this.props.empresa.empresaArchFE==="codisert"){
      tipoArch = "ARCHIVO CSV"
    // }

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large money yellow icon"></i>
          Recaudo diario
        </button>

        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones, a150520):()=>{}}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '10%'}}>
                      <h1 style={{color: '#2C7744'}}>Recaudo diario</h1>
                    </div>
                    <div className="column" style={{width: '90%'}}>
                      {(a150510===-1||sessionStorage.getItem('userLogin')==="foroptic@foroptic.com") &&
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <div className="ui six column stackable grid">
                            <div className="row container" style={{paddingBottom: 4}}>
                              <div className="column" style={{width: '17%', paddingRight: 5}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Listado general&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '14%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '18%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3_1" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales por barrio&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '19%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales en ofic y terc&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '19%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3_2" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales terc por canal&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '13%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3_3" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total mes fact</label>
                              </div>
                            </div>
                          </div>
                          <div className="ui six column stackable grid">
                            <div className="row container">
                              <div className="column" style={{width: '17%', paddingRight: 5}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion4" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Resumen general&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '14%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion5" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por día&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '18%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion5_1" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por usuario&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              <div className="column" style={{width: '19%', paddingRight: 0, paddingLeft: 0}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion6" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por contrato&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                              {a150530!==-1 &&
                                <div className="column" style={{width: '19%', paddingRight: 0, paddingLeft: 0}}>
                                  <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion7" onChange={this.handleChange}></input>
                                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Anulados</label>
                                </div>
                              }
                            </div>
                          </div>
                        </fieldset>
                      }
                      {(a150510!==-1&&sessionStorage.getItem('userLogin')!=="foroptic@foroptic.com") &&
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                          <div className="ui four column stackable grid">
                            <div className="row container" style={{paddingBottom: 10}}>
                              <div className="column" style={{width: '50%', paddingRight: 5}}>
                                <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" defaultChecked="true" onChange={this.handleChange}></input>
                                <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Totales en oficina y tercero&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      }
                    </div>
                  </div>
                </div>
                {opciones==="opcion6" &&
                  <div>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkNoFactMPF" checked={argsDocum.checkNoFactMPF} onChange={this.handleChange}/>
                      &nbsp;&nbsp;Incluir detalle de pago
                    </p>
                  </div>
                }
                <hr></hr>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    {(a150520===-1||sessionStorage.getItem('userLogin')==="foroptic@foroptic.com") &&
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Recaudo en
                        </p>
                        <Form.Field>
                          <ListaTerceros list={this.props.list} numeroDocumUA={this.props.numeroDocumUA}
                                              styles={this.props.styles} handleChange={this.handleChange}
                                              a150520={a150520}/>
                        </Form.Field>
                      </div>
                    }
                  </div>
                </div>
                {/* <hr></hr> */}
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Digitado por
                      </p>
                        <ListaUsr list={listUserRdo} styles={this.props.styles} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Oficina
                        </p>
                        <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles}
                          handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles}
                          handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciclo de facturación
                        </label>
                        <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    {(opciones!=="opcion1"&&opciones!=="opcion4"&&opciones!=="opcion6"&&
                        opciones!=="opcion3_2"&&opciones!=="opcion3_3"&&opciones!=="opcion7") &&
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Clase
                          </label>
                          <Lista styles={this.props.styles} list={this.props.list2} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    }
                  </div>
                </div>

                {(opciones==="opcion4") &&
                  <div>
                    <hr></hr>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <Form.Field>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Clase
                            </label>
                            <Lista styles={this.props.styles} list={this.props.list2} handleChange={this.handleChange}/>
                          </Form.Field>
                        </div>

                        <div className="column" style={{marginTop: 20, width: '50%'}}>
                          <fieldset>
                            <div className="ui two column stackable grid">
                              <div className="row container" style={{marginLeft: 40, marginTop: 5, marginBottom: 5}}>
                                <div className="column" style={{width: '50%', paddingRight: 5}}>
                                  <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opciones1_1" defaultChecked="true" onChange={this.handleChange}></input>
                                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Por Ciudad&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                </div>
                                <div className="column" style={{width: '50%', paddingRight: 0, paddingLeft: 0}}>
                                  <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opciones1_2" onChange={this.handleChange}></input>
                                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Por Zona&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  {totales}
                </p>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1, a150520)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    {a150501!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1, a150520)} fluid>
                        {tipoArch}
                      </Button>
                    </div>
                  }
                  {a150505!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1, a150520)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>

                {(opciones==="opcion1"||opciones==="opcion7") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Tercero</th>
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''>Rbo Caja/Fra</th>
                        <th className=''>Nodo</th>
                        <th className='right aligned'>$ Total</th>
                        <th className='right aligned'>$ Ef</th>
                        <th className='right aligned'>$ Ch</th>
                        <th className='right aligned'>$ Transf</th>
                        <th className='right aligned'>$ TD</th>
                        <th className='right aligned'>$ TC</th>
                        <th className=''>Barrio</th>
                        <th className=''>Oficina</th>
                        <th className=''>{opciones==="opcion7"?"Razón":"Digitado por"}</th>
                        {/* <th className=''>Zona</th>
                        <th className=''>Ciudad</th> */}
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion2" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Tercero</th>
                        <th className=''>Clase</th>
                        <th className=''>Concepto</th>
                        <th className=''>Periodo</th>
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''>Rbo Caja/Fra</th>
                        <th className=''>Nodo</th>
                        <th className='right aligned'>$ Detalle</th>
                        {/* <th className='right aligned'>$ Ef</th>
                        <th className='right aligned'>$ Ch</th>
                        <th className='right aligned'>$ Transf</th>
                        <th className='right aligned'>$ TD</th>
                        <th className='right aligned'>$ TC</th>
                        <th className='right aligned'>$ Detalle</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Digitado por</th>
                        {/* <th className=''>Zona</th>
                        <th className=''>Ciudad</th> */}
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion3" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Tercero</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion4" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Ciudad</th>
                        {opciones1==="opciones1_2" &&
                          <th className=''>Zona</th>
                        }
                        <th className=''>Recaudo en</th>
                        <th className=''>Clase</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }

                {opciones==="opcion5_1" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Usuario</th>
                        <th className=''>Clase</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion5" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Total pagos</th>
                        <th className=''>Fecha</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion3_1" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Total pagos</th>
                        <th className=''>Ciudad</th>
                        <th className=''>Barrio</th>
                        <th className=''>Clase</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {(opciones==="opcion6"&&!argsDocum.checkNoFactMPF) &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CONTRATO</th>
                        <th className=''>TIPO DOCUM</th>
                        <th className=''>No. DOCUM</th>
                        <th className=''>APELLIDO(S)</th>
                        <th className=''>NOMBRE(S)</th>
                        <th className=''>RAZON SOCIAL</th>
                        <th className=''>DIRECCION</th>
                        <th className=''>BARRIO</th>
                        <th className=''>DPTO</th>
                        <th className=''>CIUDAD</th>
                        <th className='right aligned'>TOTAL PAGADO</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1} checkNoFactMPF={argsDocum.checkNoFactMPF}/>
                    }
                  </table>
                }
                {(opciones==="opcion6"&&argsDocum.checkNoFactMPF) &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CONTR</th>
                        <th className=''>TIPO DOC</th>
                        <th className=''>No. DOC</th>
                        <th className=''>APELLIDO(S)</th>
                        <th className=''>NOMBRE(S)</th>
                        {/* <th className=''>RAZON SOCIAL</th> */}
                        <th className=''>DIRECCION</th>
                        <th className=''>BARRIO</th>
                        <th className=''>DPTO</th>
                        <th className=''>CIUDAD</th>
                        <th className=''>PRIM ACTIV</th>
                        <th className=''>ESTADO</th>
                        <th className=''>CLASE</th>
                        <th className=''>DETALLE PAGO</th>
                        <th className='right aligned'>TOTAL PAGADO</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1} checkNoFactMPF={argsDocum.checkNoFactMPF}/>
                    }
                  </table>
                }
                {opciones==="opcion3_2" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Tercero</th>
                        <th className=''>Canal</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }
                {opciones==="opcion3_3" &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Recaudado de</th>
                        <th className='right aligned'>$ Total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaRdo list={listRtes} opciones={opciones} opciones1={opciones1}/>
                    }
                  </table>
                }

                </div>
              </div>
              
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XXXYYYZZZ"}}}}),

  // graphql(queries.query.allPagoRtes, {name:'allPagoRtes', options: (props) => {return {variables: {fechaPago: new Date("2019-05-03")}}}}),
  graphql(queries.query.allPagoRtes, {name:'allPagoRtes', options: (props) => {return {variables: argsBuscarPC}}}),
  graphql(queries.query.allTempRdo, {name:'allTempRdo', options: (props) => {return {variables: argsBuscarPC}}}),

  graphql(queries.query.allPagoRtesGroup, {name:'allPagoRtesGroup', options: (props) => {return {variables: argsBuscarPC}}}),
  graphql(queries.query.allPagoRtesGroup, {name:'allPagoRtesGroup1', options: (props) => {return {variables: argsBuscarPC}}}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {paraProcMasDX: "SI"}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(RtesMovDi2)
